import React from 'react'
import { usePostRequest } from '../hooks/request'
import { MANTHLY_QQC_MONTHLY_ITEM_LIST } from '../urls'
import ManthlyQqcMonthlyItemForm from './ManthlyQqcMonthlyItemForm'

export default function ManthlyQqcMonthlyItemCreate({ onCancel, onSuccess, finance, qqcMonthlyId }) {
    const monthCreate = usePostRequest({ url: MANTHLY_QQC_MONTHLY_ITEM_LIST.replace('{qqcMonthlyId}', finance.id) })

    async function onSubmit(data) {
        const { success } = await monthCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <ManthlyQqcMonthlyItemForm
                finance={finance}
                qqcMonthlyId={qqcMonthlyId}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={monthCreate.loading} />
        </div>
    )
}
